import {
		SET_SESSION,
		SET_SESSION_IDS,
		RESET_SESSION_IDS,
} from './actions'

export const emptySession = {SessionID: '0'}

export function session(state = emptySession, action) {
	switch (action.type) {
		case SET_SESSION:
			return action.data
		default:
			return state;
	}
}

export function sessionIds(state = [], action) {
	switch (action.type) {
		case SET_SESSION_IDS:
			return action.data
		case RESET_SESSION_IDS:
			return []
		default:
			return state;
	}
}